import { DispatcherCustomerTemplate } from "../../Templates/DispatcherCustomerTemplate";

export const DispatcherCustomer = () => {
  return <DispatcherCustomerTemplate />;
};
